function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || "";
}
export {
  parseProtocol as default
};
//# sourceMappingURL=axios40.js.map
